import React from 'react'
import { TagLink } from './TagLink'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const TagListElm = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: .5rem;
  max-width: ${props => props.theme.maxPageContentWidth};
`

const TagListLabel = styled.div`
  padding: .5rem;
`

export const TagList = ({ tags }) => {
  const tagList = Array.isArray(tags) ? tags.map((tag) => (<TagLink key={tag} tag={tag} />)) : null
  const tagsExist = tagList && tagList.length > 0

  return tagsExist ? (
    <TagListElm>
      <TagListLabel>Tags:</TagListLabel>
      <div>{ tagsExist ? tagList : 'None'}</div>
    </TagListElm>
  ) : null
}

TagList.propTypes = {
  tags: PropTypes.array
}
